import { linkOptions } from '@tanstack/react-router';
import { ReactNode } from 'react';

import { Breadcrumbs } from '../../cdl/Breadcrumbs/Breadcrumbs';
import { Text } from '../../cdl/Text/Text';
import { translate } from '../../common/helpers/translate.helper';
import { useDocumentTitle } from '../../common/hooks/useDocumentTitle';
import { Page } from '../../common/Page/Page';
import { Box } from '../../common/ui/Box';

interface CompanyOverviewPageProps {
    children: ReactNode;
}

export const CompanyOverviewPage = ({ children }: CompanyOverviewPageProps) => {
    useDocumentTitle(translate('settings.companyManagement.title'));

    return (
        <Page>
            <Box display="grid" gap={40}>
                <Box display="grid" gap={4}>
                    <Breadcrumbs
                        links={[
                            {
                                label: translate('settings.title'),
                                linkOptions: linkOptions({ to: '/settings' }),
                            },
                        ]}
                    />
                    <Text variant="headline" as="h1">
                        {translate('settings.companyManagement.title')}
                    </Text>
                </Box>

                {children}
            </Box>
        </Page>
    );
};
